import React from 'react';

import ChevronRightIcon from '../../assets/images/Icons/ChevronRight';
import { COLORS } from '../../config/designSystem/Colors';
import { Caption2Bold } from '../../config/designSystem/typography';
import { SPACING } from '../../config/designSystem/Spacing';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';


interface ButtonProps {
  onPress: () => void;
  label: string;
  style?: StyleProp<ViewStyle>;

}

export const DesignSystemButtonWithArrow = ({ label, onPress, style}: ButtonProps) => {
  const SIZE_ICON= 24;
  return (
    <TouchableOpacity
      style={[
        {
          paddingVertical: SPACING['sp-4'],
          alignItems:'center',
          flexDirection:'row',
          columnGap: SPACING['sp-4'],
        },
        !!style && style
      ]}
      onPress={onPress}
    >

      <Caption2Bold color={COLORS.content.accent}>{label}</Caption2Bold>
      <ChevronRightIcon width={SIZE_ICON} height={SIZE_ICON} color={COLORS.content.accent}/>
    </TouchableOpacity>
  );
};

